import { Alert, DialogActions, DialogContent, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import { useForm } from "react-hook-form";
import { changePassword } from "../../api/auth";
import { RegularButton } from "../Button";

export default function PasswordChange(props) {
  const { onClose, open } = props;
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();
  const [showAlert, setShowAlert] = React.useState(false);
  const [showErrorAlert, setShowErrorAlert] = React.useState(false);

  const handleClose = () => {
    onClose();
  };

  const onsubmit = (data) => {
    changePassword(data).then(
      (success) => {
        setShowErrorAlert(false);
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
          handleClose();
        }, 2000);
      },
      (error) => {
        console.log(error);
        if (error.response.status === 400) {
          if (error.response?.data?.new_password1) {
            setError("new_password1", {
              type: "server",
              message: error.response.data.new_password1[0],
            });
          }
          if (error.response?.data?.new_password2) {
            setError("new_password2", {
              type: "server",
              message: error.response.data.new_password2[0],
            });
          }
        } else {
          setShowErrorAlert(true);
        }
      },
    );
  };
  const onerror = (err) => {};

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: "form",
        onSubmit: handleSubmit(onsubmit, onerror),
      }}
    >
      <DialogTitle>パスワード変更</DialogTitle>
      <DialogContent sx={{ width: "420px" }}>
        <TextField
          autoFocus
          required
          margin="dense"
          id="new_password1"
          name="new_password1"
          label="新パスワード"
          type="password"
          fullWidth
          variant="standard"
          {...register("new_password1", {
            required: "新パスワードは必須です",
          })}
          error={"new_password1" in errors}
          helperText={errors.new_password1?.message}
        />
        <TextField
          required
          margin="dense"
          id="new_password2"
          name="new_password2"
          label="新パスワード(確認用)"
          type="password"
          fullWidth
          variant="standard"
          {...register("new_password2", {
            required: "新パスワード(確認用)は必須です",
          })}
          error={"new_password2" in errors}
          helperText={errors.new_password2?.message}
        />
      </DialogContent>
      <Alert
        severity="success"
        sx={{
          width: "100%",
          padding: "0 20px",
          display: showAlert ? "flex" : "none",
        }}
      >
        パスワードを変更しました
      </Alert>
      <Alert
        severity="error"
        sx={{
          width: "100%",
          padding: "0 20px",
          display: showErrorAlert ? "flex" : "none",
        }}
      >
        エラーが発生しました
      </Alert>
      <DialogActions>
        <Button onClick={handleClose}>キャンセル</Button>
        <RegularButton
          type="submit"
          variant="contained"
          color="primary"
          size="medium"
          disabled={showAlert}
        >
          変更
        </RegularButton>
      </DialogActions>
    </Dialog>
  );
}
